"use client";

import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { fetchData } from "@/api/api";
import ShopArea from "@/components/shop/shop-area";
import Wrapper from "@/layout/wrapper";
import Header from "@/layout/headers/header";
import Footer from "@/layout/footers/footer";
import Loader from "@/components/Loader";

export default function ShopPage() {
  const searchParams = useSearchParams();
  const categoryId = searchParams.get("category"); // synchronous in client

  const [allProducts, setAllProducts] = useState([]);
  const [categoryName, setCategoryName] = useState("All Products");

  useEffect(() => {
    const fetchDataAsync = async () => {
      const categoriesRes = await fetchData({ url: "/customer/categories" });
      const productsRes = await fetchData({ url: "/customer/products?limit=500" });

      const filteredProducts = productsRes?.data?.filter((p: any) =>
        categoryId ? p.categoryId.toString() === categoryId : true
      );

      setAllProducts(filteredProducts || []);

      const catName = categoriesRes?.data?.find((c: any) => c.id === categoryId)?.name;
      setCategoryName(catName || "All Products");
    };

    fetchDataAsync();
  }, [categoryId]);

  return  <Wrapper>


      <Header />
      <main>
       
        <ShopArea allProducts={allProducts || []} categoryName={categoryName || "All Products"} />
      </main>
      <Footer />
    </Wrapper>;
}
